
<template>
    <div class="d-flex flex-row mb-2">
        <div v-for="(child,i) in element.childs"
            :key="i"
            class="modal_element"
            :class="[hoveredCol == i ? 'hoveredElement' : 'notHoveredElement',
                     isMobile ? 'element_width_mobile' : 'element_width'
                     ]"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            @click="selectElement(child)"
            @mouseover="hoverCol(i, child.selected)"
            @mouseleave="hoverCol(1000)"
        >
            <img
                :class="isMobile ? 'img_size_mobile' : 'img_size_desktop'"
                :src="child.image"
                alt
            />
            <div class="my-2 descriptionElement">{{child.name}}</div>
            <div  v-show="app.currentConfiguration.priceList.show_prices == 1" class="my-2">
                {{ child.price | currency }} {{ child.unit_type == "" ? "" : "/" }} {{child.unit_type}}
            </div>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import JQuery from "jquery";
let $ = JQuery;

export default {
    name: "productVariantsComponent",

    components: { Fragment },

    data() {
        return {
            app: app,
            hoveredCol: 100,
            window: { width: 0, height: 0 },
        };
    },

    props: {
        element: new Object()
    },

    computed: {
        isMobile: function () {
            let a = this.window.width < 580;
            return a;
        }
    },

    methods: {
        selectElement(selectedChild) {
            this.$emit("variantChanged", selectedChild);
        },
        hoverCol(numCol){
            this.hoveredCol = numCol;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },

    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },

    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

};
</script>

<style scoped lang="scss">

.img_size_mobile {
    width: 170px;
    height: 170px;
}

.img_size_desktop {
    width: 220px;
    height: 220px;
}
.descriptionElement{
    height:70px;
    overflow:hidden;
}
.element_width{
    width: 220px;
    overflow: hidden;
}
.element_width_mobile{
    width: 170px;
}
.hoveredElement{
    background-color:	#F0F0F0;
    border: 1px solid #e2001a;
}

.notHoveredElement{
    margin: 1px;
}

</style>
